import { useRef, useState } from 'react';
import { useToast } from '../context/ToastContext';

const CORES = {
  sucesso: { bg: '#d1e7dd', border: '#a3cfbb', texto: '#0f5132', icone: '✓' },
  erro: { bg: '#f8d7da', border: '#f1aeb5', texto: '#842029', icone: '✕' },
  info: { bg: '#cff4fc', border: '#9eeaf9', texto: '#055160', icone: 'ℹ' },
};

// Limiar de arrasto (px) pra descartar (pedido por Jason 2026-09-19:
// "opção de arrastar pra tirar ela da página") — abaixo disso, volta pro
// lugar com uma transição suave.
const LIMIAR_DESCARTE_PX = 100;

function ToastCard({ toast, onDismiss }) {
  const [dragX, setDragX] = useState(0);
  const [arrastando, setArrastando] = useState(false);
  const inicioX = useRef(0);
  const cor = CORES[toast.tipo] || CORES.info;

  function aoPressionar(e) {
    setArrastando(true);
    inicioX.current = e.clientX - dragX;
    e.currentTarget.setPointerCapture(e.pointerId);
  }

  function aoMover(e) {
    if (!arrastando) return;
    setDragX(e.clientX - inicioX.current);
  }

  function aoSoltar() {
    setArrastando(false);
    if (Math.abs(dragX) > LIMIAR_DESCARTE_PX) {
      onDismiss(toast.id);
    } else {
      setDragX(0);
    }
  }

  return (
    <div
      role="alert"
      onPointerDown={aoPressionar}
      onPointerMove={aoMover}
      onPointerUp={aoSoltar}
      onPointerCancel={aoSoltar}
      style={{
        backgroundColor: cor.bg,
        border: `1px solid ${cor.border}`,
        color: cor.texto,
        borderRadius: 8,
        padding: '12px 16px',
        marginBottom: 8,
        // nunca mais larga que a tela (celular de 320px)
        width: 'min(380px, calc(100vw - 32px))',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        cursor: arrastando ? 'grabbing' : 'grab',
        userSelect: 'none',
        touchAction: 'pan-y',
        transform: `translateX(${dragX}px)`,
        opacity: Math.max(0.15, 1 - Math.abs(dragX) / 250),
        transition: arrastando ? 'none' : 'transform 0.2s ease, opacity 0.2s ease',
      }}
    >
      <strong style={{ fontSize: 16 }}>{cor.icone}</strong>
      <div style={{ flex: 1, fontSize: 14 }}>{toast.mensagem}</div>
      <button
        type="button"
        onClick={() => onDismiss(toast.id)}
        aria-label="Fechar"
        style={{
          background: 'none',
          border: 'none',
          color: cor.texto,
          fontSize: 18,
          lineHeight: 1,
          cursor: 'pointer',
          padding: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}

// Canto superior direito, sobre tudo (`zIndex` alto) — pedido por Jason:
// "todas as notificações devem ser Toast". Montado uma vez em App.js,
// fora do `<Routes>`, pra sobreviver a navegação entre páginas.
export default function ToastViewport() {
  const { toasts, remover } = useToast();
  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {toasts.map((t) => (
        <ToastCard key={t.id} toast={t} onDismiss={remover} />
      ))}
    </div>
  );
}
